import Login from "../../components/loginExt";

const LoginPage = () => {
  return <Login></Login>;
};

export default LoginPage;
